{
  "brand": "Dashboard Garage",
  "nav": {
    "devices": "Devices",
    "connections": "Data sources",
    "settings": "Settings",
    "logout": "Log out",
    "exitDemo": "Leave demo",
    "skip": "Skip to content",
    "main": "Main",
    "demo": "Demo",
    "language": "Language"
  },
  "demo": {
    "bannerText": "Demo mode: everything you change stays in this private sandbox and disappears in {{hours}} h.",
    "cta": "Want this on your desk? Request a quote",
    "landing": {
      "eyebrow": "Try it yourself",
      "title": "Put your KPIs on real gauges",
      "lead": "This is the same panel our customers use. Assign KPIs to the dials of an original cluster, set scales, thresholds and colours, switch report sets, and watch the needles move with live sample data from an online shop.",
      "points": [
        "No account, no email",
        "Your own private sandbox for 24 hours",
        "Sample data only: nothing to connect"
      ],
      "enter": "Enter demo",
      "entering": "Preparing your demo…",
      "error": "The demo couldn't start right now. Please try again in a moment.",
      "haveAccount": "Customer? Log in"
    }
  },
  "login": {
    "title": "Log in",
    "email": "Email",
    "password": "Password",
    "submit": "Log in",
    "error": "Wrong email or password.",
    "tryDemo": "Just looking? Try the demo"
  },
  "devices": {
    "title": "Your devices",
    "empty": "No devices yet.",
    "open": "Configure",
    "status": {
      "online": "Online",
      "offline": "Offline",
      "stale": "Data stale",
      "never_connected": "Not connected yet"
    },
    "lastSeen": "Last seen",
    "firmware": "Firmware",
    "signal": "Wi-Fi signal",
    "syncPending": "Latest changes not on the unit yet"
  },
  "configurator": {
    "reportSets": "Report sets",
    "reportSetsHint": "On the unit, the rotary switch in the base picks the active set.",
    "addSet": "Add set",
    "newSetName": "New set",
    "position": "Switch position {{n}}",
    "colorMode": "Status colours",
    "colorModeStatus": "By status (green / amber / red)",
    "colorModeFixed": "Fixed colour",
    "clickGauge": "Click a gauge to assign a KPI.",
    "unassigned": "Not assigned",
    "stale": "Stale",
    "alert": "Alert",
    "onUnit": "on the unit now",
    "setName": "Set name",
    "removeSet": "Remove this set",
    "removeSetConfirm": "Yes, remove the set and its gauges"
  },
  "editor": {
    "title": "{{gauge}}",
    "dialRange": "Dial prints {{min}}–{{max}} {{unit}}",
    "metric": "KPI",
    "noMetric": "Not assigned",
    "unitLabel": "Label on the dial",
    "kpiMin": "KPI at dial minimum",
    "kpiMax": "KPI at dial maximum",
    "multiplier": "Scale multiplier",
    "multiplierHint": "Numbers on the dial = KPI ÷ multiplier (printed as ×1000 etc.)",
    "redline": "Redline starts at",
    "alertTitle": "Alert",
    "alertWhen": "Alert when KPI is",
    "above": "above",
    "below": "below",
    "none": "no alert",
    "threshold": "Threshold",
    "alertNeedle": "Push needle into the redline on alert",
    "statusTitle": "Status colour",
    "statusNone": "No status colour",
    "higherBetter": "Higher is better",
    "lowerBetter": "Lower is better",
    "amberAt": "Amber at",
    "redAt": "Red at",
    "damping": "Needle smoothing",
    "dampingValue": "{{ms}} ms to settle",
    "save": "Save gauge",
    "saving": "Saving…",
    "saved": "Saved",
    "remove": "Clear gauge",
    "current": "Current value",
    "invalid": "Please check the values: {{details}}",
    "lightMode": "How this lamp is driven",
    "lightModeRule": "By a KPI rule",
    "lightModeManual": "Manually (fixed state)",
    "lightState": "Lamp state",
    "lightOff": "Off",
    "lightOn": "On",
    "lightBlink": "Blinking",
    "lightManualHint": "The lamp stays like this until you change it: useful to test a lamp or flag something by hand.",
    "lightWhen": "Light up when KPI is",
    "lightBlinkAlways": "Blink whenever the lamp is on",
    "lightBlinkAt": "Start blinking at",
    "lightBlinkAtHint": "Optional second threshold, further {{direction}}: the lamp is steady first and blinks once the KPI gets worse.",
    "optional": "optional",
    "alertLight": "Warning lamp on alert",
    "noLight": "No lamp",
    "staleLight": "Warning lamp when data is stale"
  },
  "connections": {
    "title": "Data sources",
    "lead": "Where your KPI values come from. Credentials are encrypted on our server and never shown again after saving.",
    "demoNote": "In the demo, data comes from a simulated online shop. The other sources are examples of what you can connect in your own panel; no real credentials can be entered here.",
    "example": "Example",
    "lastOk": "Last successful fetch",
    "lastError": "Last error",
    "never": "never",
    "test": "Test",
    "testing": "Testing…",
    "secretSet": "Credentials saved",
    "types": {
      "bigquery": "BigQuery",
      "ga4": "Google Analytics 4",
      "meta": "Meta Ads and Pixel",
      "google_ads": "Google Ads",
      "search_console": "Google Search Console",
      "woocommerce": "WooCommerce",
      "shoper": "Shoper",
      "stripe": "Stripe",
      "youtube": "YouTube",
      "postgres": "PostgreSQL",
      "rest": "REST API",
      "webhook": "Webhook (push)",
      "customer_endpoint": "Your own endpoint",
      "sample": "Sample data"
    },
    "add": "Add data source",
    "cancel": "Cancel",
    "create": "Save data source",
    "delete": "Delete",
    "name": "Name",
    "type": "Type",
    "fields": {
      "project": "Project ID",
      "dataset": "Dataset",
      "table": "Table",
      "location": "Location (optional)",
      "serviceAccount": "Service account key (JSON)",
      "mode": "What to read",
      "modePublic": "Public stats (API key)",
      "modeOwner": "Owner analytics (your OAuth client)",
      "channel": "Channel ID (UC…) or @handle",
      "apiKey": "API key (restricted to YouTube Data API v3)",
      "publishing": "Your OAuth app status",
      "testing": "Testing (tokens expire after 7 days)",
      "production": "In production",
      "clientId": "OAuth client ID",
      "clientSecret": "OAuth client secret",
      "host": "Host",
      "port": "Port",
      "database": "Database",
      "user": "User (read-only recommended)",
      "ssl": "Use SSL",
      "password": "Password",
      "url": "URL (https)",
      "headerName": "Header name",
      "headerValue": "Header value (token)",
      "endpointToken": "Bearer token",
      "propertyId": "GA4 property ID",
      "propertyIdHint": "The number from Admin → Property details, not the G-… measurement ID.",
      "adAccountId": "Ad account ID",
      "adAccountIdHint": "The number from Ads Manager, with or without the act_ prefix.",
      "pixelId": "Pixel ID (optional)",
      "pixelIdHint": "Only needed for pixel event counts.",
      "metaToken": "System user access token (ads_read)",
      "customerId": "Customer ID",
      "customerIdHint": "10 digits, shown at the top of Google Ads.",
      "loginCustomerId": "Manager account ID (optional)",
      "loginCustomerIdHint": "Fill in when you reach the account through a manager (MCC) account.",
      "developerToken": "Developer token",
      "siteUrl": "Property",
      "siteUrlHint": "Exactly as in Search Console: https://example.com/ or sc-domain:example.com",
      "shopUrl": "Shop address (https)",
      "consumerKey": "Consumer key",
      "consumerSecret": "Consumer secret",
      "currency": "Currency",
      "currencyHint": "3-letter code, e.g. PLN. Payments in other currencies are not counted.",
      "stripeKey": "Restricted API key (read: Charges, Balance)",
      "timezone": "Shop time zone",
      "webapiLogin": "WebAPI user login",
      "webapiPassword": "WebAPI user password"
    },
    "secretHint": "Encrypted on our server. It is never shown again, not even to you.",
    "guide": "Setup guide",
    "webhookCreated": "Webhook ready. Copy the token now: it won't be shown again.",
    "webhookUrl": "Webhook URL",
    "webhookToken": "Token",
    "webhookExample": "Example",
    "oauth": {
      "not_authorized": "Not authorized",
      "ok": "Authorized",
      "expiring": "Expires soon",
      "expired": "Authorization expired",
      "expiresOn": "Authorization expires {{date}} (app in Testing).",
      "authorize": "Authorize with Google",
      "reauthorize": "Authorize again",
      "redirect": "Redirect URI to add in your OAuth client:",
      "result": {
        "ok": "Google authorization saved.",
        "denied": "Authorization was cancelled.",
        "failed": "Authorization failed: see the error below.",
        "invalid_state": "The authorization link expired. Please try again."
      }
    },
    "metrics": {
      "title": "KPIs",
      "lead": "Each KPI is one number read from a data source. Assign KPIs to gauges in the configurator.",
      "add": "Add KPI",
      "name": "KPI name",
      "source": "Data source",
      "unit": "Unit",
      "refresh": "Refresh every (seconds)",
      "staleAfter": "Stale after (minutes, empty = default)",
      "latest": "Latest",
      "none": "no value yet",
      "delete": "Delete",
      "sourceFields": {
        "kpi_name": "kpi_name in the table",
        "metric": "Statistic",
        "sql": "SQL (must return one row with a \"value\" column)",
        "json_path": "JSON path, e.g. data.revenue",
        "key": "Key in the pushed JSON",
        "kpi": "Sample KPI",
        "ga4_metric": "GA4 metric (API name)",
        "ga4_range": "Period",
        "ga4_range_hint": "Days are counted in the time zone of the GA4 property. \"Last 30 minutes\" supports only a few metrics, such as activeUsers.",
        "meta_metric": "Meta metric",
        "meta_range_hint": "Ad metrics follow the days of the ad account; \"last 7 / 28 days\" are full days without today. Pixel metrics (pixel:…) count events in the last hour or 24 hours.",
        "ads_range_hint": "Days are counted in the time zone of the Google Ads account. \"Last 7 / 30 days\" are full days without today.",
        "gsc_range_hint": "Search Console finishes counting a day after two to three days, so every period ends three days ago.",
        "woo_range_hint": "Week, month and year are the current ones so far. average_sales is the average per day of the period.",
        "stripe_range_hint": "\"Today\" starts at midnight UTC. Balance KPIs ignore the period.",
        "shoper_range_hint": "\"Today\" starts at midnight in the shop's time zone. All orders placed in the period are counted, whatever their status."
      },
      "ga4Ranges": {
        "realtime": "Last 30 minutes (realtime)",
        "today": "Today",
        "yesterday": "Yesterday",
        "7d": "Last 7 days",
        "28d": "Last 28 days",
        "month_to_date": "This month so far"
      },
      "metaRanges": {
        "today": "Today",
        "yesterday": "Yesterday",
        "7d": "Last 7 days",
        "28d": "Last 28 days",
        "month_to_date": "This month so far",
        "last_hour": "Last hour",
        "24h": "Last 24 hours"
      },
      "adsRanges": {
        "today": "Today",
        "yesterday": "Yesterday",
        "7d": "Last 7 days",
        "30d": "Last 30 days",
        "month_to_date": "This month so far"
      },
      "gscRanges": {
        "7d": "7 days",
        "28d": "28 days",
        "90d": "90 days"
      },
      "wooRanges": {
        "today": "Today",
        "week": "This week",
        "month": "This month",
        "last_month": "Last month",
        "year": "This year"
      },
      "stripeRanges": {
        "today": "Today",
        "24h": "Last 24 hours",
        "7d": "Last 7 days"
      },
      "shoperRanges": {
        "today": "Today",
        "24h": "Last 24 hours",
        "7d": "Last 7 days",
        "30d": "Last 30 days"
      }
    }
  },
  "settings": {
    "title": "Settings",
    "staleTitle": "When data is stale",
    "staleAfter": "Treat values as stale after (minutes)",
    "staleNeedle": "Needle while stale",
    "staleHold": "Hold the last value",
    "staleMin": "Rest at the dial minimum",
    "colors": "Colours",
    "ok": "OK",
    "warn": "Warning",
    "alert": "Alert",
    "staleColor": "Stale",
    "neutral": "Neutral",
    "save": "Save settings",
    "saved": "Saved"
  },
  "consent": {
    "title": "Cookies and analytics",
    "text": "We use analytics cookies only if you allow them, to improve the panel and the demo. Nothing is loaded before you choose.",
    "accept": "Accept all",
    "reject": "Reject all"
  },
  "common": {
    "loading": "Loading…",
    "error": "Something went wrong.",
    "retry": "Retry",
    "notFound": "Page not found",
    "back": "Back"
  },
  "guides": {
    "back": "Back to data sources",
    "screenshot": "Screenshot placeholder"
  },
  "health": {
    "title": "Unit status",
    "lastSeen": "Last contact",
    "never": "never",
    "activeSet": "Active set",
    "unknownSet": "Unknown set",
    "firmware": "Firmware",
    "signal": "Wi-Fi signal",
    "uptime": "Uptime",
    "freeHeap": "Free memory",
    "token": "Device token",
    "rotationPending": "new token issued, waiting for the unit",
    "errors_one": "The unit reported {{count}} error",
    "errors_other": "The unit reported {{count}} errors",
    "sync": {
      "synced": "Configuration on the unit is up to date (version {{current}}).",
      "pending": "The unit has version {{applied}}, the latest is {{current}}. It picks up changes within a few minutes.",
      "unknown": "The unit hasn't reported its configuration version yet."
    }
  },
  "deviceAdmin": {
    "add": "Add device",
    "addManual": "Add by serial number",
    "pair": "Pair a device",
    "pairTitle": "Pair a device",
    "pairHint": "Connect the unit to Wi-Fi: it shows a 6-digit pairing code. Enter the code here within 10 minutes. The unit is then assigned to your account and downloads its token by itself.",
    "pairCode": "Pairing code",
    "pairCreate": "Pair",
    "paired": "{{serial}} is now assigned to your account. The unit picks up its token within a few seconds; then assign KPIs to its gauges.",
    "repaired": "{{serial}} was paired again. Its report sets and gauges are unchanged; the unit gets a new token within a few seconds.",
    "addTitle": "Add a device",
    "title": "Manage device",
    "name": "Name",
    "namePlaceholder": "e.g. Office desk",
    "serial": "Serial number",
    "serialHint": "Use the unit's serial number (unique, e.g. DG-0002). After saving you get the device token: it is shown only once and goes into the unit's firmware configuration.",
    "model": "Cluster",
    "create": "Add device",
    "rename": "Rename",
    "tokenOnce": "Token for {{serial}}. Copy it now: it won't be shown again.",
    "tokenHint": "Put it in the unit's firmware configuration. The unit sends it with every request (Authorization: Bearer …).",
    "copy": "Copy",
    "copied": "Copied",
    "done": "Done",
    "rotate": "Issue a new token",
    "rotateConfirm": "Yes, issue a new token",
    "rotateHint": "If the token leaked or the unit is being set up again. The current token keeps working until the unit first uses the new one.",
    "delete": "Remove device",
    "deleteWarn": "This removes {{serial}}, its report sets and gauge assignments. The unit stops receiving data.",
    "deleteConfirm": "Yes, remove",
    "errors": {
      "serial_taken": "A device with this serial number is already registered.",
      "unknown_cluster_model": "Unknown cluster model.",
      "invalid_body": "Check the name and serial number (3–40 characters: letters, digits, - and _).",
      "pairing_code_invalid": "This code is not valid or has expired. Check the code on the unit, or restart pairing on the unit to get a new one.",
      "serial_registered_elsewhere": "This unit is registered to another account. Contact us to have it transferred.",
      "rate_limited": "Too many attempts. Wait a minute and try again."
    }
  },
  "history": {
    "title": "History: {{name}}",
    "range": "Time range",
    "range24": "24 h",
    "range168": "7 days",
    "empty": "No history yet. Values appear here once the data source has been polled.",
    "latest": "Latest",
    "min": "Min",
    "max": "Max",
    "summary": "{{name}} history: min {{min}}{{unit}}, max {{max}}{{unit}}, latest {{latest}}{{unit}}"
  }
}
